function queryFormat(value, key) {
  if (value !== null && typeof value === 'object') return query(value, key);else return encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function query(params, prefix = null) {
  const str = [];

  for (const param in params) {
    str.push(queryFormat(params[param], prefix ? `${prefix}[${param}]` : param));
  }

  return str.join('&');
}

export { query };
